/* Nextmac menu: mobiel schermvullend menu + desktop mega-menu */
(function () {
  if (window.__nmMenu) return;
  window.__nmMenu = true;

  /* ---------------- Mobiel ---------------- */
  var menu, openKnop, laatsteFocus;

  function scherm(naam) {
    if (!menu) return;
    var doel = menu.querySelector('[data-nm-scherm="' + naam + '"]');
    if (!doel) return;
    menu.querySelectorAll('[data-nm-scherm]').forEach(function (s) {
      var actief = s === doel;
      s.classList.toggle('is-actief', actief);
      s.classList.toggle('is-links', !actief && s.getAttribute('data-nm-scherm') === 'hoofd' && naam !== 'hoofd');
      s.setAttribute('aria-hidden', actief ? 'false' : 'true');
      if (actief) {
        var inh = s.querySelector('.nm-menu__inhoud');
        if (inh && naam !== 'hoofd') inh.scrollTop = 0;
      }
    });
    menu.querySelectorAll('[data-nm-naar]').forEach(function (b) {
      b.setAttribute('aria-expanded', b.getAttribute('data-nm-naar') === naam ? 'true' : 'false');
    });
    var focus = doel.querySelector(naam === 'hoofd' ? '[data-nm-menu-dicht]' : '[data-nm-terug]');
    if (focus) setTimeout(function () { focus.focus({ preventScroll: true }); }, 30);
  }

  function open() {
    if (!menu) return;
    laatsteFocus = document.activeElement;
    menu.hidden = false;
    scherm('hoofd');
    requestAnimationFrame(function () { menu.classList.add('is-open'); });
    document.body.classList.add('nm-menu-open');
    if (openKnop) openKnop.setAttribute('aria-expanded', 'true');
  }

  function dicht() {
    if (!menu || menu.hidden) return;
    menu.classList.remove('is-open');
    document.body.classList.remove('nm-menu-open');
    if (openKnop) openKnop.setAttribute('aria-expanded', 'false');
    setTimeout(function () { menu.hidden = true; scherm('hoofd'); }, 200);
    if (laatsteFocus && laatsteFocus.focus) laatsteFocus.focus({ preventScroll: true });
  }

  function startMobiel() {
    menu = document.querySelector('[data-nm-menu]');
    openKnop = document.querySelector('[data-nm-menu-open]');
    if (!menu) return;
    // Buiten de (sticky) header plaatsen, zodat 'position: fixed' altijd het hele scherm pakt
    if (menu.parentNode !== document.body) document.body.appendChild(menu);
  }

  document.addEventListener('click', function (e) {
    if (e.target.closest('[data-nm-menu-open]')) { e.preventDefault(); open(); return; }
    if (!menu || menu.hidden) return;
    if (e.target.closest('[data-nm-menu-dicht]')) { dicht(); return; }
    if (e.target.closest('[data-nm-terug]')) { scherm('hoofd'); return; }
    var naar = e.target.closest('[data-nm-naar]');
    if (naar) { scherm(naar.getAttribute('data-nm-naar')); return; }
  });

  /* ---------------- Desktop mega-menu ---------------- */
  var openItem = null, timer = null;

  function dim(aan) {
    var d = document.querySelector('[data-nm-mega-dim]');
    if (aan) {
      // Vanaf de onderkant van de header tot onderaan het scherm
      var hw = document.querySelector('.header-wrapper') || document.querySelector('header');
      var onder = hw ? Math.max(0, Math.round(hw.getBoundingClientRect().bottom)) : 0;
      document.documentElement.style.setProperty('--nm-kop-onder', onder + 'px');
      scrollStart = window.scrollY;
    }
    if (d) d.classList.toggle('is-zichtbaar', !!aan);
  }
  var scrollStart = 0;
  window.addEventListener('scroll', function () {
    if (openItem && Math.abs(window.scrollY - scrollStart) > 24) zet(null);
  }, { passive: true });

  function zet(item) {
    if (openItem === item) return;
    // wisselen tussen twee panelen gebeurt direct, zodat ze nooit tegelijk zichtbaar zijn
    var nav = document.querySelector('.nm-mega-nav');
    if (nav) nav.classList.toggle('is-wissel', !!(openItem && item));
    if (openItem) {
      openItem.classList.remove('is-open');
      var b0 = openItem.querySelector('.nm-mega-nav__link');
      if (b0) b0.setAttribute('aria-expanded', 'false');
    }
    openItem = item;
    if (item) {
      item.classList.add('is-open');
      var b = item.querySelector('.nm-mega-nav__link');
      if (b) b.setAttribute('aria-expanded', 'true');
    }
    dim(!!item);
  }

  function isDesktop() { return window.matchMedia('(min-width: 990px)').matches; }

  var aanraak = false;
  function startDesktop() {
    document.querySelectorAll('[data-nm-mega]').forEach(function (item) {
      if (item.__nm) return;
      item.__nm = true;
      item.addEventListener('mouseenter', function () {
        if (!isDesktop()) return;
        clearTimeout(timer);
        timer = setTimeout(function () { zet(item); }, openItem ? 0 : 90);
      });
      item.addEventListener('mouseleave', function () {
        clearTimeout(timer);
        timer = setTimeout(function () { if (openItem === item) zet(null); }, 160);
      });
      var knop = item.querySelector('.nm-mega-nav__link');
      if (knop) {
        knop.addEventListener('pointerdown', function (e) { aanraak = e.pointerType === 'touch' || e.pointerType === 'pen'; });
        knop.addEventListener('click', function (e) {
          clearTimeout(timer);
          // muis: naar de algemene collectie. Touch: eerste tik opent het paneel, tweede tik gaat naar de collectie
          if (aanraak && openItem !== item) { e.preventDefault(); zet(item); return; }
          zet(null);
        });
        knop.addEventListener('keydown', function (e) {
          if (e.key === 'ArrowDown' || e.key === ' ') { e.preventDefault(); clearTimeout(timer); zet(item); var eerste = item.querySelector('.nm-mega a'); if (eerste) eerste.focus({ preventScroll: true }); }
        });
      }
      item.addEventListener('focusout', function () {
        setTimeout(function () { if (openItem === item && !item.contains(document.activeElement)) zet(null); }, 0);
      });
    });
    var d = document.querySelector('[data-nm-mega-dim]');
    if (d) d.addEventListener('click', function () { zet(null); });
  }

  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    if (menu && !menu.hidden) { dicht(); return; }
    if (openItem) {
      var b = openItem.querySelector('.nm-mega-nav__link');
      zet(null);
      if (b) b.focus();
    }
  });

  window.addEventListener('resize', function () {
    if (isDesktop()) dicht(); else zet(null);
  });

  /* ---------------- ZOEKEN (direct in de zoekbalk) ---------------- */
  function euro(v) {
    var n = parseFloat(v);
    if (isNaN(n)) return '';
    return '€' + n.toLocaleString('nl-NL', { minimumFractionDigits: n % 1 ? 2 : 0, maximumFractionDigits: 2 });
  }
  function esc(t) { return String(t == null ? '' : t).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }

  function startZoek() {
    var wrap = document.querySelector('[data-nm-zoek]');
    if (!wrap || wrap.__nm) return;
    wrap.__nm = true;
    var input = wrap.querySelector('[data-nm-zoek-input]');
    var paneel = wrap.querySelector('[data-nm-zoek-paneel]');
    var populair = wrap.querySelector('[data-nm-zoek-populair]');
    var res = wrap.querySelector('[data-nm-zoek-resultaat]');
    var wis = wrap.querySelector('[data-nm-zoek-wis]');
    var hint = wrap.querySelector('[data-nm-zoek-hint]');
    var typ = wrap.querySelector('[data-nm-zoek-typ]');
    var timer = null, ctrl = null, laatste = '';

    function open(aan) {
      paneel.hidden = !aan;
      input.setAttribute('aria-expanded', aan ? 'true' : 'false');
      wrap.classList.toggle('is-open', aan);
    }
    function status() {
      var leeg = !input.value;
      wis.hidden = leeg;
      wrap.classList.toggle('heeft-tekst', !leeg);
    }
    function toon(q, data) {
      var r = (data && data.resources && data.resources.results) || {};
      var html = '';
      var qs = (r.queries || []).slice(0, 5);
      if (qs.length) {
        html += '<p class="nm-zoek__label">Suggesties</p><ul class="nm-zoek__lijst" role="list">';
        qs.forEach(function (x) { html += '<li><a class="nm-zoek__rij" href="' + esc(x.url) + '">' + (x.styled_text || esc(x.text)) + '</a></li>'; });
        html += '</ul>';
      }
      var cs = (r.collections || []).slice(0, 4);
      if (cs.length) {
        html += '<p class="nm-zoek__label">Categorieën</p><ul class="nm-zoek__chips" role="list">';
        cs.forEach(function (x) { html += '<li><a class="nm-zoek__chip" href="' + esc(x.url) + '">' + esc(x.title) + '</a></li>'; });
        html += '</ul>';
      }
      var ps = (r.products || []).slice(0, 5);
      if (ps.length) {
        html += '<p class="nm-zoek__label">Producten</p><ul class="nm-zoek__producten" role="list">';
        ps.forEach(function (x) {
          var img = x.image ? x.image + (x.image.indexOf('?') > -1 ? '&' : '?') + 'width=120' : '';
          var vanaf = x.price_max && x.price_min && x.price_max !== x.price_min;
          html += '<li><a class="nm-zoek__product" href="' + esc(x.url) + '">' +
            '<span class="nm-zoek__foto">' + (img ? '<img src="' + esc(img) + '" alt="" width="56" height="56" loading="lazy">' : '') + '</span>' +
            '<span class="nm-zoek__ptekst"><span class="nm-zoek__pnaam">' + esc(x.title) + '</span>' +
            '<span class="nm-zoek__pprijs">' + (vanaf ? '<small>vanaf</small> ' : '') + euro(x.price_min || x.price) + '</span></span></a></li>';
        });
        html += '</ul>';
      }
      if (!html) html = '<p class="nm-zoek__leeg">Geen resultaten voor "' + esc(q) + '". Probeer een ander woord, zoals MacBook, iPhone of ThinkPad.</p>';
      html += '<a class="nm-zoek__alles" href="/search?q=' + encodeURIComponent(q) + '&options%5Bprefix%5D=last">Toon alle resultaten voor "' + esc(q) + '"</a>';
      res.innerHTML = html;
      populair.hidden = true;
    }
    function zoek() {
      var q = input.value.trim();
      if (q === laatste) return;
      laatste = q;
      if (!q) { res.innerHTML = ''; populair.hidden = false; return; }
      if (ctrl) ctrl.abort();
      ctrl = window.AbortController ? new AbortController() : null;
      var url = '/search/suggest.json?q=' + encodeURIComponent(q) + '&resources[type]=query,collection,product&resources[limit]=6&resources[options][unavailable_products]=last';
      fetch(url, ctrl ? { signal: ctrl.signal } : {})
        .then(function (r) { return r.json(); })
        .then(function (j) { if (input.value.trim() === q) toon(q, j); })
        .catch(function () {});
    }
    input.addEventListener('focus', function () { open(true); stopTypen(); });
    input.addEventListener('blur', function () { setTimeout(function () { if (!input.value && !wrap.classList.contains('is-open')) startTypen(); }, 150); });
    input.addEventListener('input', function () {
      status(); open(true);
      clearTimeout(timer); timer = setTimeout(zoek, 160);
    });
    input.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') { open(false); input.blur(); }
    });
    wis.addEventListener('click', function () { input.value = ''; status(); zoek(); input.focus(); });
    document.addEventListener('click', function (e) { if (!wrap.contains(e.target)) { open(false); if (!input.value && document.activeElement !== input) startTypen(); } });
    status();

    /* Bewegende voorbeeldtekst, zoals bij Back Market */
    var woorden = ['MacBook Air', 'iPhone 15', 'Lenovo ThinkPad', 'iPad', 'MacBook Pro', 'Surface Laptop', 'iPhone 13', 'Apple Watch'];
    var wi = 0, ci = woorden[0].length, weg = true, tt = null, loopt = false;
    var rustig = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    function stap() {
      if (!loopt) return;
      if (document.hidden) { tt = setTimeout(stap, 800); return; }
      var w = woorden[wi];
      var wacht = 70;
      if (weg) {
        ci--;
        wacht = 35;
        if (ci <= 0) { ci = 0; weg = false; wi = (wi + 1) % woorden.length; wacht = 300; }
      } else {
        ci++;
        w = woorden[wi];
        if (ci >= w.length) { ci = w.length; weg = true; wacht = 1800; }
      }
      typ.textContent = woorden[wi].slice(0, ci);
      tt = setTimeout(stap, wacht);
    }
    function startTypen() {
      if (rustig || loopt || input.value || document.activeElement === input) return;
      loopt = true; hint.hidden = false; tt = setTimeout(stap, 1800);
    }
    function stopTypen() { loopt = false; clearTimeout(tt); hint.hidden = true; }
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (en) { if (en[0].isIntersecting) startTypen(); else { loopt = false; clearTimeout(tt); } }).observe(wrap);
    } else startTypen();
  }

  function start() { startMobiel(); startDesktop(); startZoek(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
})();
